var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41389 5C5.68218 5 5.93921 5.1078 6.12723 5.29918L12.499 11.7847C12.8868 12.1794 12.8803 12.8141 12.4845 13.2008L5.81771 19.7152C5.63089 19.8978 5.38004 20 5.11883 20H2.45424C1.55775 20 1.11416 18.9113 1.75536 18.2848L6.94347 13.2152C7.34496 12.8229 7.34496 12.1771 6.94347 11.7848L1.75535 6.71523C1.11415 6.08869 1.55775 5 2.45424 5H5.41389Z",
    fill: "url(#paint0_linear_5808_40842)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2122 5C16.4805 5 16.7376 5.1078 16.9256 5.29918L23.2973 11.7847C23.6851 12.1794 23.6786 12.8141 23.2829 13.2008L16.6161 19.7152C16.4292 19.8978 16.1784 20 15.9172 20H13.2526C12.3561 20 11.9125 18.9113 12.5537 18.2848L17.7418 13.2152C18.1433 12.8229 18.1433 12.1771 17.7418 11.7848L12.5537 6.71523C11.9125 6.08869 12.3561 5 13.2526 5H16.2122Z",
    fill: "url(#paint1_linear_5808_40842)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5808_40842",
    x1: 4.71489,
    y1: 17.9643,
    x2: 14.529,
    y2: 4.99093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E29C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC84C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5808_40842",
    x1: 15.5132,
    y1: 17.9643,
    x2: 25.3273,
    y2: 4.99093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E29C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC84C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardArrow);
export default __webpack_public_path__ + "static/media/card-arrow.0679a339f1174c9dd6e03b9091670887.svg";
export { ForwardRef as ReactComponent };